import React,{useState,useEffect} from 'react';
import FormControl from '@mui/material/FormControl';
//import FormLabel from '@mui/material/FormLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
//import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
//import PasswordIcon from '@mui/icons-material/Password';
import TextsmsIcon from '@mui/icons-material/Textsms';
import BottomButtons from './BottomButtons';
import InputString from './InputString';
import {Theme} from './Theme';
//import {Tools} from './Tools';
import {Inc,Secret,Item,Owner,SecretAnswerLengthMin,SecretAnswerLengthMax,SecretQuestionLengthMin,SecretQuestionLengthMax} from './Inc';
import useStyles from './Styles';
import StoreImg from './StoreImg';

interface Props {
	isOpen:boolean,
	owner:Owner,
    items:Item[],
    send(secret:Secret):void,
    close(): void,
}

const SecretConfirm: React.FC<Props> = (props)=> {
    const classes = useStyles();
	const defValues = {
		secret:Inc.defaultSecret(),
		errors: {
			answer: true,
			question: false,
		},
	};
    const [values, setValues] = useState(defValues);

	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));

	const onChangeString = (name:keyof Secret) => (value: string,hasError: boolean) => {
		setValues({...values,secret:{...values.secret,[name]:value},errors:{...values.errors,[name]:hasError}});
	};

	const autoAnswer = ()=>{
		//const n = Math.floor(Math.random()*3)+7;
		const n = 8;
		const answer = generateRandomString(n)
		setValues({...values,secret:{...values.secret,answer:answer},errors:{...values.errors,'answer':false}});
	}

	const generateRandomString = (num:number) => {
		//const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-=+';
		const characters ='あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわをんがぎぐげござじずぜぞたぢづでどばびぶべぼぱぴぷぺぽ';
		let result = '';
		const charactersLength = characters.length;
		for (let i = 0; i < num; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
	  
		return result;
	}

	const send = ()=>{
		props.send(values.secret);
	}

	useEffect(()=>{
		if(props.isOpen){
			setValues(defValues);
		}
	},[props.isOpen]);

	if(!props.isOpen){
		return (null);
	}
	return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}			
		>
			<DialogTitle color='primary'>パスワード設定</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					パスワードを入力して「登録する」を押して下さい。ランダムなパスワードを自動作成することもできます。<br/>
					<div style={{fontSize:'85%',marginTop:'1em',color:'#666666'}}>
					※お客様に対して具体的な質問やヒントを表示したい場合はメッセージ（秘密の質問）に入力して下さい。<br/>
					※同じパスワードが設定されている商品が複数ある場合、一回のパスワード入力ですべての商品が閲覧可能になります。<br/>
					</div>
				</div>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<InputString
							label="パスワード"
							required={true}
							value={values.secret.answer}
							onChange={onChangeString('answer')}
							helper={SecretAnswerLengthMin+'文字以上'+SecretAnswerLengthMax+'文字以内'}
							opt={{minLength:SecretAnswerLengthMin,maxLength:SecretAnswerLengthMax,endAdornment:<Tooltip placement="top" arrow={true} open={true} title="自動作成"><IconButton size="small" onClick={autoAnswer}><TextsmsIcon color="info"/></IconButton></Tooltip>}}
						/>
					</Grid>
					<Grid item xs={12}>
						<InputString
							label="メッセージ（秘密の質問）"
							required={false}
							value={values.secret.question}
							onChange={onChangeString('question')}
							helper={SecretQuestionLengthMin+'文字以上'+SecretQuestionLengthMax+'文字以内・省略可'}
							opt={{minLength:SecretQuestionLengthMin,maxLength:SecretQuestionLengthMax}}
						/>
					</Grid>
				</Grid>
				<Divider style={{marginTop:'1em',marginBottom:'1em'}}/>
				<FormControl fullWidth={true} style={{marginBottom:"1.5em"}}>
					<List disablePadding>
					{props.items.map((item:Item,index:number)=>{
						const key = "item"+index;
						return (
							<ListItem key={key} style={{margin:'0.5em 0em',paddingRight:'0'}} dense>
								<ListItemAvatar style={{marginLeft:'-1em',marginRight:'1em'}}><StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} thumb={true} className="imgList"/></ListItemAvatar>
								<ListItemText primary={(<><span className={classes.itemId}>ID:{item.item_id}</span><br/><span>{item.item_name}</span></>)} secondary=""/>
							</ListItem>
						)
					})}
					</List>
				</FormControl>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='登録する' onClick1={send} disabled1={values.errors.answer || values.errors.question} button2='やりなおし' onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default SecretConfirm;
